import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { AuthService } from '../auth/auth.service';
import { DownloadService } from './download.service';
import { mapJsonObjectToServer } from './map-json-server-object';

export interface PdfModel {
  name: string; // name to give to the file
  url: string; // url of the page in the angular app

  shouldWriteToFile?: boolean;
  canOverwriteIfExists?: boolean;
  // shouldConvertToWord?: boolean;

  header: string;
  footer: string;
  headerHeight?: number;
  footerHeight?: number;
}

@Injectable({ providedIn: 'root' })
export class PdfService {
  constructor(private downloadService: DownloadService, private authService: AuthService) {}

  /** For Docx or Pdf */
  generateAndDownload(model: PdfModel): Observable<any> {
    const url = environment.apiRoot + '/pdf';
    // const fileName = model.name + (model.shouldConvertToWord ? ".docx" : ".pdf");
    const fileName = model.name + '.pdf';
    model = mapJsonObjectToServer({
      ...model,
      token: this.authService.accessToken,
    });

    return this.downloadService.download('Generate PDF...', fileName, (httpClient) =>
      httpClient.post(url, model, { responseType: 'blob' })
    );
  }
}
